/** ISO 4217 currency code used for all price display across the app. */
export const APP_CURRENCY = 'CAD';
